import { FC } from 'react';

export const WlasSnippetIcon: FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="1.5" y="2.5" width="13" height="11" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M5 6.5L3 8.5L5 10.5M11 6.5L13 8.5L11 10.5M8.5 5.5L7.5 11.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
